
module.exports = require('isomorphic-fetch');



/*****************
 ** WEBPACK FOOTER
 ** ./~/dva/fetch.js
 ** module id = 309
 ** module chunks = 1
 **/